import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LoginUserinfo, Campaign, CampaignByName } from '../redux/apicalling/dispatchfunction';
import Select, { components } from 'react-select';
import '../assets/css/queuepage.css'

function Queuepage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let payload = {};
  const [queuevalue, setQueuevalue] = useState([]);
  const [queuename, setQueuenames] = useState([]);

  const [campaignvalue, setCampaignvalue] = useState('');
  const [campaignname, setCampaignnames] = useState([]);
  const [campaignlist, setCampaignlist] = useState([]); // full campaign objects, masking lookup ku

  const que_agentname = localStorage.getItem("username")
  const config_data = JSON.parse(localStorage.getItem("config"))

  let queue_value = config_data.projects[0].queue
  const tenant_code = config_data.projects[0].tenant_code
  let config_user = config_data.projects[0].userInfo[0].user_email
  const station = config_data.projects[0].userInfo[0].user_phone_number
  let agent_name = config_data.projects[0].userInfo[0].user_name

    payload['agent_id'] = agent_name
    payload['avatar_url'] = ""
    payload['campaign'] = campaignvalue
    payload['station'] = station
    payload['user'] = config_user
    payload['queue'] =  queuevalue.toString()


  useEffect(() => {
    setQueuenames([]);
  }, []);

  // Campaign dropdown - independent, mount aana odaney fetch pannum
 useEffect(() => {
    dispatch(Campaign({ user: que_agentname })).then((response) => {
      if (response && response.status === 200) {
        const campaignList = response.data.data;
        setCampaignlist(campaignList);

        // FIXED: field name confirmed as "name"
        const extractedCampaignNames = campaignList.map(c => ({
          value: c.name,
          label: c.name
        }));
        setCampaignnames(extractedCampaignNames);
      }
    }).catch((err) => {
      return err
    });
  }, []);
  const handlequeuevaluedropdown = (event) => {
    let selectedStatus = [];
    for (let i = 0; i < event.length; i++) {
      const element = event[i].value;
      selectedStatus.push(element)
    }
    setQueuevalue(selectedStatus);
  };

  // Campaign select  
 const handlecampaignvaluedropdown = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : '';
    setCampaignvalue(selectedValue);

    localStorage.setItem('selectedcampaign', selectedValue);
    setQueuevalue([]);

    if (selectedValue) {
      dispatch(CampaignByName({ user: que_agentname, name: selectedValue })).then((response) => {
        if (response && response.status === 200) {
          const campaignData = response.data.data;
          localStorage.setItem('campaigndetails', JSON.stringify(campaignData));

          if (campaignData.length > 0 && campaignData[0].ingroup) {
            const ingroupQueues = campaignData[0].ingroup.split(',').map(q => ({
              value: q.trim(),
              label: q.trim()
            }));
            setQueuenames(ingroupQueues);
          }

          const maskingEnabled = campaignData.length > 0 && (campaignData[0].masking === "true" || campaignData[0].masking === true);
          localStorage.setItem('number_mask', JSON.stringify(maskingEnabled));
        }
      }).catch((err) => {
        return err
      });
    }
  };

  const handleQueuevalue = (event) => {

    if (queuevalue.length === 0) {
        setQueuevalue([]);
        return;
      }

    localStorage.setItem('queuelogin',true)

    dispatch(LoginUserinfo(payload)).then((response) => {
        if (response.status === 200) {
          localStorage.setItem('login', true);
          localStorage.setItem('agentstatus', true);
          navigate('/homepage')
       }
      }).catch((err)=>{
        return err
      })
  };


   const CustomOption = (props) => (
    <div title={props.label}>
      <components.Option {...props} />
    </div>
  );

  const CustomMultiValueLabel = (props) => (
    <components.MultiValueLabel {...props}>
      <div title={props.data.label}>{props.data.label}</div>
    </components.MultiValueLabel>
  );



  return (

<div>

         <div className='bgcover'>
        <div className='cam-box-container'>
        <div className='cam-body-container'>

        {/* Campaign dropdown - independent, always visible */}
        <div >
          <div className='queue-placeholdertext' style={{paddingLeft:'40px'}}> {"Select Campaign "}</div>
        <div className='cam-selectinlinestyle'>
          <Select
            isMulti={false}
            isDisabled={false}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            menuPortalTarget={document.body}
            menuShouldScrollIntoView={true}
            menuPlacement={`auto`}
            onChange={handlecampaignvaluedropdown}
            options={campaignname}
            isSearchable={true}
            className="basic-single-select"
            classNamePrefix="select"
            placeholder={'Select Campaign'}
          />
        </div>
        </div>
        {/* {campaignvalue === '' && <p className="queue-error-message">* Please select the campaign value</p>}
        {campaignvalue !== '' && <p className="queue-error-message">* Campaign Selected</p>} */}

        <div style={{paddingTop:'60px'}}>
          <div className='queue-placeholdertext'> {"Select Queue "}</div>

        <input className='cam-input' type="text"  value={station} readOnly={true} />

        <div className='cam-selectinlinestyle'>

            <Select
            isMulti={true}
            isDisabled={false}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({
                ...base,
                minHeight: '42px',
                maxHeight: '100px',
              }),
              valueContainer: (base) => ({
                ...base,
                maxHeight: '100px',
                overflowY: 'auto',
                flexWrap: 'wrap',
                flexDirection: 'column',
                alignContent: 'flex-start',
              }),
              multiValue: (base) => ({
                ...base,
                width: '100%',
              }),
            }}
            menuPortalTarget={document.body}
            menuShouldScrollIntoView={true}
            menuPlacement={`auto`}
            onChange={handlequeuevaluedropdown}
            value={queuename.filter(q => queuevalue.includes(q.value))}
            options={queuename}
            isSearchable={true}
            className="basic-multi-select"
            classNamePrefix="select"
            placeholder={'Select Queues'}
              components={{
                Option: CustomOption,
                MultiValueLabel: CustomMultiValueLabel,
              }}
          />

        </div>

        </div>
          {queuevalue.length === 0 && <p className="queue-error-message">* Please select the queue value</p>}
          {queuevalue.length !== 0 && <p className="queue-error-message">* Queue Selected</p>}

          <button type="button" className="queue-button" onClick={handleQueuevalue} disabled={queuevalue.length === 0 || campaignvalue === ''} >
            Proceed
          </button>


        </div>
        </div>



          </div>

      </div>



  )
}
export default Queuepage;